// extracted by mini-css-extract-plugin
export default {"bouton":"BoutonPdfTelechargeable_bouton__DAMZ5"};